import { render, staticRenderFns } from "./OauthClientEdit.vue?vue&type=template&id=3e381d45&scoped=true"
import script from "./OauthClientEdit.vue?vue&type=script&lang=js"
export * from "./OauthClientEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e381d45",
  null
  
)

export default component.exports